export default "__VITE_ASSET__DEW6wWGW__"